var map = {
	"./base/bg.webp": 8253,
	"./base/logo.webp": 3741,
	"./base/logo_base.webp": 3967,
	"./bimo/bg.webp": 9565,
	"./bimo/logo.webp": 746,
	"./dulcesol/bg.webp": 9377,
	"./dulcesol/logo.webp": 8745,
	"./dulcesol/logo_new.webp": 9504,
	"./dz/bg.webp": 7656,
	"./dz/logo.webp": 9344,
	"./dz/logo_base.webp": 2264,
	"./hayat/bg.webp": 3231,
	"./hayat/logo.webp": 9707,
	"./hb/bg-uncropped.webp": 4415,
	"./hb/bg.webp": 7148,
	"./hb/bg0.webp": 3692,
	"./hb/bg1.webp": 783,
	"./hb/bg3.webp": 8057,
	"./hb/bg4.webp": 512,
	"./hb/logo.webp": 3612,
	"./hb/logo0.webp": 44,
	"./hb/logo1.webp": 1631,
	"./hb/old-bg.webp": 3284,
	"./henkeldz/bg.webp": 3867,
	"./henkeldz/bg1.webp": 6850,
	"./henkeldz/logo.webp": 4911,
	"./ifri/bg.webp": 8952,
	"./ifri/logo.webp": 6080,
	"./palmary/bg.webp": 7844,
	"./palmary/bg_new.webp": 3057,
	"./palmary/logo.webp": 5604,
	"./palmary/logo1.webp": 6983,
	"./rouiba/bg.webp": 6034,
	"./rouiba/logo.webp": 646,
	"./rouiba1/logo_ar.webp": 3071,
	"./rouiba1/logo_ar_.webp": 5720,
	"./rouiba1/logo_fr.webp": 7388,
	"./rouiba1/logo_fr_.webp": 6341,
	"./swalis/bg-.webp": 5762,
	"./swalis/logo.webp": 9923
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5952;